import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="pub pub-footer">
      <div className="pub-wrap">
        <div className="pub-footer-grid">
          <div>
            <Link to="/" className="pub-logo">SIGMA</Link>
            <p style={{ marginTop: 14, maxWidth: '38ch' }}>
              Wnioski urlopowe i pula urlopowa pracowników w jednym miejscu. Dla pracodawców i ich zespołów.
            </p>
          </div>
          <div>
            <h4>Produkt</h4>
            <ul>
              <li><Link to="/">Dla firm</Link></li>
              <li><Link to="/dla-pracownikow">Dla pracowników</Link></li>
              <li><Link to="/pricing">Cennik</Link></li>
            </ul>
          </div>
          <div>
            <h4>Informacje</h4>
            <ul>
              <li><Link to="/about">O nas</Link></li>
              <li><Link to="/contact">Kontakt</Link></li>
              <li><Link to="/terms">Regulamin</Link></li>
              <li><Link to="/privacy">Polityka prywatności</Link></li>
              <li><a href="https://akademiafachowca.edu.pl" target="_blank" rel="noopener noreferrer">Akademia Fachowca</a></li>
            </ul>
          </div>
        </div>
        <div className="pub-footer-bottom">© {new Date().getFullYear()} SigmaWork</div>
      </div>
    </footer>
  );
}

export default Footer;
